import agent from './agent';
import config from '../config.json';
import ServiceBase from './ServiceBase';

const baseUrl = config.baseUrl;
const service = 'journal';

class JournalServiceAgent extends ServiceBase {
    /**
     * Activates user after Clerk signup.
     * @param {string} uid
     * @param {string} tier
     * @returns {Promise}
     */
    activateUser = (uid, tier) => {
        const url = `${baseUrl}/${service}/user/activate`;
        const config = {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
                'Content-Type': 'application/json',
            },
        };
        return agent.post(url, { uid, tier }, config);
    };

    /**
     *  get Journal
     *
     * @param {object} dto - { rk?, title, body, format, templateVer }
     */
    createJournal = (dto) => {
        const url = `${baseUrl}/${service}/journal/create`;
        const config = {
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return agent.post(url, dto, config);
    };
}

const journalService = new JournalServiceAgent();
export default journalService;
